import { takeLatest } from "redux-saga/effects"

import { apiGeneratorBase } from "../../Utils/saga"
import Creators, { MarketingTypes as constants } from "./reducer"
import * as services from "./services"

const actions = {
  getMarketingLinksActions: {
    request: Creators.getMarketingLinksRequest,
    success: Creators.getMarketingLinksSuccess,
    errors: Creators.marketingFailure
  },
  getSourceDataActions: {
    request: Creators.getSourceDataRequest,
    success: Creators.getSourceDataSuccess,
    errors: Creators.marketingFailure
  },
  getCampaignDataActions: {
    request: Creators.getCampaignDataRequest,
    success: Creators.getCampaignDataSuccess,
    errors: Creators.marketingFailure
  },
  getTotalUsersActions: {
    request: Creators.getTotalUsersRequest,
    success: Creators.getTotalUsersSuccess,
    errors: Creators.marketingFailure
  },
  createSourceActions: {
    request: Creators.createSourceRequest,
    success: Creators.createSourceSuccess,
    errors: Creators.marketingFailure,
    extraAction: [Creators.getSourceRequest]
  },
  createCampaignActions: {
    request: Creators.createCampaignRequest,
    success: Creators.createCampaignSuccess,
    errors: Creators.marketingFailure,
    extraAction: [Creators.getCampaignRequest]
  },
  getSourceActions: {
    request: Creators.getSourceRequest,
    success: Creators.getSourceSuccess,
    errors: Creators.getSourceFailure
  },
  getCampaignActions: {
    request: Creators.getCampaignRequest,
    success: Creators.getCampaignSuccess,
    errors: Creators.getCampaignFailure
  },
  generateLinkActions: {
    request: Creators.generateLinkRequest,
    success: Creators.generateLinkSuccess,
    errors: Creators.marketingFailure
  },
  getLinkUsersActions: {
    request: Creators.getLinkUsersRequest,
    success: Creators.getLinkUsersSuccess,
    errors: Creators.getLinkUsersFailure
  }
}

const eventsOptions = {
  [constants.GET_MARKETING_LINKS_REQUEST]: {
    api: services.getMarketingLinks,
    actions: actions.getMarketingLinksActions
  },
  [constants.GET_SOURCE_DATA_REQUEST]: {
    api: services.getSourceData,
    actions: actions.getSourceDataActions
  },
  [constants.GET_CAMPAIGN_DATA_REQUEST]: {
    api: services.getCampaignData,
    actions: actions.getCampaignDataActions
  },
  [constants.GET_TOTAL_USERS_REQUEST]: {
    api: services.getTotalUsers,
    actions: actions.getTotalUsersActions
  },
  [constants.CREATE_SOURCE_REQUEST]: {
    api: services.createSource,
    actions: actions.createSourceActions
  },
  [constants.CREATE_CAMPAIGN_REQUEST]: {
    api: services.createCampaign,
    actions: actions.createCampaignActions
  },
  [constants.GET_SOURCE_REQUEST]: {
    api: services.getSource,
    actions: actions.getSourceActions
  },
  [constants.GET_CAMPAIGN_REQUEST]: {
    api: services.getCampaign,
    actions: actions.getCampaignActions
  },
  [constants.GENERATE_LINK_REQUEST]: {
    api: services.generateLink,
    actions: actions.generateLinkActions
  },
  [constants.GET_LINK_USERS_REQUEST]: {
    api: services.getMarketingLinkUsers,
    actions: actions.getLinkUsersActions
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.GET_MARKETING_LINKS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_MARKETING_LINKS_REQUEST])
  )
  yield takeLatest(constants.GET_SOURCE_DATA_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_SOURCE_DATA_REQUEST])
  )
  yield takeLatest(constants.GET_CAMPAIGN_DATA_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_CAMPAIGN_DATA_REQUEST])
  )
  yield takeLatest(constants.GET_TOTAL_USERS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_TOTAL_USERS_REQUEST])
  )
  yield takeLatest(constants.GET_SOURCE_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_SOURCE_REQUEST])
  )
  yield takeLatest(constants.GET_CAMPAIGN_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_CAMPAIGN_REQUEST])
  )
  yield takeLatest(constants.CREATE_SOURCE_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.CREATE_SOURCE_REQUEST])
  )
  yield takeLatest(constants.CREATE_CAMPAIGN_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.CREATE_CAMPAIGN_REQUEST])
  )
  yield takeLatest(constants.GENERATE_LINK_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GENERATE_LINK_REQUEST])
  )
  yield takeLatest(constants.GET_LINK_USERS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_LINK_USERS_REQUEST])
  )
}
